import React from 'react'
import PropTypes from 'prop-types'
import {icon} from '@salesforce/retail-react-app/app/components/icons'
import {useCustomTheme} from '../../../context/theme'

import '../../../assets/svg/kenwood/kenwood-brand-logo.svg'
import '../../../assets/svg/delonghi/delonghi-brand-logo.svg'
import '../../../assets/svg/nutribullet/nutribullet-brand-logo.svg'
import '../../../assets/svg/nutribullet/nutribullet-brand-logo-inverted.svg'

const DelonghiBrandLogo = icon('delonghi-brand-logo', {viewBox: '0 0 169 55'})
const DelonghiBrandLogoInverted = icon('delonghi-brand-logo-inverted', {viewBox: '0 0 169 55'})
const KenwoodBrandLogo = icon('kenwood-brand-logo', {viewBox: '0 0 180 27'})
const NutribulletBrandLogo = icon('nutribullet-brand-logo', {viewBox: '0 0 120 34'})
const NutribulletBrandLogoInverted = icon('nutribullet-brand-logo-inverted', {
    viewBox: '0 0 120 34',
})

const BrandLogo = (props) => {
    const {theme} = useCustomTheme()

    let Icon = null
    switch (theme.key) {
        case 'nutribullet':
            Icon = NutribulletBrandLogo
            if (props.inverted) {
                Icon = NutribulletBrandLogoInverted
            }
            break
        case 'kenwood':
            Icon = KenwoodBrandLogo
            break
        case 'delonghi':
        default:
            Icon = DelonghiBrandLogo
            if (props.inverted) {
                Icon = DelonghiBrandLogoInverted
            }
            break
    }

    return <Icon {...props} inverted={props.inverted ? 'true' : undefined} />
}

BrandLogo.propTypes = {
    onClick: PropTypes.func,
    inverted: PropTypes.bool,
}

export default BrandLogo
